import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Title')(({ theme }) =>
  css({
    mb: theme.space.default,
    mt: 'xl',
  }),
);

themeStyles.addBaseStyles('Disclaimer')(({ theme }) =>
  css({
    padding: ['s', 's', '0'],
    my: ['0', '0', theme.space.default],
  }),
);

export default themeStyles;
